export const Logo = () => (
  <span className="flex items-center gap-2" data-testid="brand-logo">
    <img src="/logo-96.webp" srcSet="/logo-96.webp 1x, /logo-192.webp 2x" alt="" width="96" height="96" className="h-8 w-8 rounded-[22%]" />
    <span className="text-xl font-bold tracking-[-0.02em] text-black">
      GetTaxcy<span className="text-[#FFD000]">.</span>
    </span>
  </span>
);
